import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "trainFilled"
const TrainFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 1.5C14.578 1.5 16.464 1.975 17.654 2.413 18.896 2.87 19.5 4.078 19.5 5.25V14.197C19.5 15.26 19.11 16.402 18.162 17.1L22.28 21.22C22.573 21.513 22.573 21.987 22.28 22.28 21.988 22.573 21.513 22.573 21.22 22.28L20.69 21.75H3.31L2.78 22.28C2.489 22.573 2.014 22.573 1.72 22.28S1.427 21.513 1.72 21.22L5.84 17.1C4.89 16.403 4.5 15.26 4.5 14.197V5.25C4.5 4.078 5.105 2.87 6.347 2.413 7.537 1.975 9.423 1.5 12 1.5M4.81 20.25H19.19L17.69 18.75H6.31zM7.126 13.5V15H9.375C9.375 14.172 8.704 13.5 7.875 13.5zM16.125 13.5C15.297 13.5 14.625 14.172 14.625 15H16.875V13.5zM6 10.06Q6.004 10.06 6.008 10.062C6.259 10.19 6.648 10.364 7.175 10.54 8.228 10.889 9.835 11.25 12 11.25S15.773 10.89 16.826 10.539C17.352 10.363 17.742 10.189 17.993 10.063Q17.997 10.063 18 10.06V6H6z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default TrainFilledIcon
